import { CardIssuer } from "./CardIssuer";

export const innCodesMap = {
  [CardIssuer.AmericanExpress]: [34, 37],
  [CardIssuer.Unionpay]: [62, 88],
  [CardIssuer.DinersClub]: [[300, 305], 3095, 36, [38, 39]],
  [CardIssuer.Discover]: [
    6011,
    [622126, 622925],
    64,
    65,
    [624000, 626999],
    [628200, 628899],
  ],
  [CardIssuer.InterPayment]: [636],
  [CardIssuer.InstaPayment]: [[637, 639]],
  [CardIssuer.Jcb]: [[3528, 3589]],
  [CardIssuer.Laser]: [6304, 6706, 6771, 6709],
  [CardIssuer.Maestro]: [
    5018,
    5020,
    5038,
    5612,
    5893,
    6759,
    6761,
    6762,
    6763,
    6390,
    [56, 69],
    50,
  ],
  [CardIssuer.Dankort]: [5019, 4571],
  [CardIssuer.MasterCard]: [
    [51, 55],
    [2221, 2720],
  ],
  [CardIssuer.Visa]: [4],
  [CardIssuer.Uatp]: [1],
  [CardIssuer.Mir]: [[2200, 2204]],
  [CardIssuer.Alfbank]: [5555],
};
